import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export interface UseMeQueryOptions {
  enabled?: boolean;
}

/**
 * The calling user from `GET /v1/users/me`, with the zones they manage.
 * Zone assignments rarely change, so it stays fresh for a while;
 * `useInvalidateZones` refetches it after managers are edited.
 */
export const useMeQuery = ({ enabled = true }: UseMeQueryOptions = {}) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: ["useMeQuery", apiClient.slug],
    queryFn: async () => {
      const res = await apiClient.organizations.userMe();
      return res.result;
    },
    enabled: enabled && !!apiClient.slug,
    staleTime: 5 * 60 * 1000
  });
};
